import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerCardAgent: {
      width: "374px",
      maxWidth: "374px",
      minWidth: "250px",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",

    },
    containerHeaderInfo:{
      width:'240px'
    },
    wrapperImgProf: {
      width: "56px",
      height: "56px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    divider: {
      backgroundColor: theme.palette.border.secondary,
    },
    fullWidth: {
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      border: `1px solid rgba(0, 0, 0, 0.08)`,
    },
    containerImgName: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      alignItems: "flex-start",
      minHeight:'75px'
    },
    containerCourses: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerCourse: {
      display: "flex",
      flexDirection: "column",
    },
    containerHeaderCourse: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      alignItems: "center",
    },
    conatinerShowMore: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%",
    },
    agentNameTitle: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "28px",
      color: theme.palette.text.secondary,
    },
    courseNameTitle: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    courseDesc: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "18px",
      color: theme.palette.text.tertiary,
    },
  };
});
